import * as React from "react";
import {
	FilterList,
	FilterListItem,
	Filter,
	SearchInput,
	ReferenceInput,
	DateInput,
	BooleanInput,
	SelectInput,
} from "react-admin";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import CustomAutocompleteInput from "../custom/CustomAutocompleteInput";
import {
	Adjust as StatusIcon,
	TrackChanges as TargetIcon,
	Category as CategoryIcon,
} from "@material-ui/icons";
import { Box } from "@material-ui/core";

export const SearchFilter = (props) => (
	<Filter {...props}>
		<SearchInput source="q" alwaysOn />
	</Filter>
);

export const ReferenceAutoComplete = ({
	label,
	source,
	reference,
	referenceSource,
	optionText,
	...props
}) => {
	const condition = (val) => val.trim().length > 0;

	return (
		<Filter {...props}>
			<ReferenceInput
				label={label || ""}
				source={source || "id"}
				reference={reference}
				perPage={10}
				alwaysOn
				sort={{ field: "autoComplete", order: "DESC" }}
			>
				<CustomAutocompleteInput
					shouldRenderSuggestions={condition}
					loaded={true}
					loading={false}
					optionText={optionText || "id"}
					resettable
					alwaysOn
				/>
			</ReferenceInput>
		</Filter>
	);
};

export const SelectFilter = (props) => {
	return (
		<FilterList {...props}>
			<Filter>
				<SelectInput
					{...props}
					optionValue={"value"}
					optionText={"text"}
					emptyText={"(not set)"}
					emptyValue={null}
					label={""}
					alwaysOn
				/>
			</Filter>
		</FilterList>
	);
};
